import { Autoplay, Grid } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useState } from 'react';
import { useSelector } from 'react-redux';

import SwiperFooter from 'components/global/SwiperFooter';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import ModuleCard from '../ModuleCard';
import * as S from './ModuleDetail.styled';

const RelatedModules = () => {
	const { selectedModule } = useSelector((state) => state.otoPackageList);
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const [swiperRef, setSwiperRef] = useState(null);

	if (!selectedModule?.relatedModules?.length) {
		return null;
	}

	return (
		<>
			<S.Line />
			<S.RelatedModules>
				<Typography variant="h2" fontWeight="800" noWrap>
					relatedModules
				</Typography>
				<S.RelatedModulesList>
					<Swiper
						modules={[Autoplay, Grid]}
						spaceBetween={24}
						slidesPerView={isMobile ? 1 : 3}
						autoplay={{
							delay: 5000,
							disableOnInteraction: false
						}}
						onSwiper={setSwiperRef}>
						{selectedModule?.relatedModules?.map((module) => (
							<SwiperSlide key={module.id}>
								<ModuleCard key={module.id} module={module} />
							</SwiperSlide>
						))}

						{selectedModule?.relatedModules?.length > (isMobile ? 1 : 3) && swiperRef && (
							<SwiperFooter cssPosition="relative" swiperRef={swiperRef} />
						)}
					</Swiper>
				</S.RelatedModulesList>
			</S.RelatedModules>
		</>
	);
};

export default RelatedModules;
